import { createContext, FC, useContext } from 'react'

/**
 * Where the sound of the stage's recordings is to come out. Tools ask this
 * instead of knowing about presenter mode (`presenter-mode/`), which
 * provides it where the trainer chose speakers.
 */
export type StageAudioOutput = {
	/** What `setSinkId` takes: an output device's id, `''` for the system default. */
	sinkId: string
	/** The browser refused to play through `sinkId`; the player fell back to the default. */
	onRefused: (sinkId: string) => void
}

const SYSTEM_DEFAULT: StageAudioOutput = {
	sinkId: '',
	onRefused: () => undefined,
}

const StageAudioOutputContext = createContext<StageAudioOutput>(SYSTEM_DEFAULT)

export const ProvideStageAudioOutput: FC<{ output: StageAudioOutput }> = ({
	output,
	children,
}) => (
	<StageAudioOutputContext.Provider value={output}>
		{children}
	</StageAudioOutputContext.Provider>
)

/** The system default output, unless presenter mode says otherwise. */
export const useStageAudioOutput = (): StageAudioOutput =>
	useContext(StageAudioOutputContext)
